function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Colors from "styles/colors";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { TAB_CLICKED } from "/constants/bigbrain-event-types";
import classnames from "classnames";
import Title from "segments/desktop/core-components/title/title";
import { XS_L } from "constants/sizes";
import { BACKGROUND_GRAY_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
import { isDarkTheme } from "segments/segments-service";
import { StyledTabComponent } from "./tab-component.scss";
class TabComponent extends PureComponent {
    onTabClicked(e) {
        this.blurTab(e);
        this.tabClickedAction();
    }
    render() {
        const { label, hideLabel, color, backgroundColor, isActive, useSmallLabels, tabIcon, useXSMLabels, tabsWithIcons, tabClassName, theme, unsetLabelColor } = this.props;
        const tabColor = Colors[color];
        const tabLabel = hideLabel ? "" : label;
        const defaultTabLabelColor = isDarkTheme(theme) ? Colors[WHITE_COLOR_NAME] : Colors.mud;
        const tabLabelColor = isActive ? tabColor : defaultTabLabelColor;
        const unsetTabLabelcolor = ()=>{
            return unsetLabelColor && isDarkTheme(theme) && !isActive;
        };
        return /*#__PURE__*/ _jsxs(StyledTabComponent, {
            className: classnames("tab-component", {
                active: isActive,
                "small-labels": useSmallLabels,
                "half-screen-tabs": useXSMLabels,
                [tabClassName]: tabClassName
            }),
            style: {
                "--tab-color": tabColor,
                "--tab-background-color": Colors[backgroundColor] || Colors[BACKGROUND_GRAY_COLOR_NAME]
            },
            onClick: this.onTabClicked,
            role: "tab",
            "aria-selected": isActive,
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            children: [
                !tabsWithIcons && /*#__PURE__*/ _jsx("span", {
                    className: "tab-label",
                    style: unsetTabLabelcolor() ? {} : {
                        color: tabLabelColor
                    },
                    children: tabLabel
                }),
                tabsWithIcons && /*#__PURE__*/ _jsx("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ _jsx(Title, {
                        title: tabLabel,
                        titleIcon: tabIcon === null || tabIcon === void 0 ? void 0 : tabIcon.src,
                        titleSize: XS_L
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "tab-underline-placeholder",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "tab-underline",
                        style: {
                            background: tabColor
                        }
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "blurTab", (e)=>{
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".tab-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property(this, "tabClickedAction", ()=>{
            const { onClick, index, label, labelTranslationKey, extraData } = this.props;
            BigBrain("track", TAB_CLICKED, {
                kind: label,
                info1: index,
                info2: labelTranslationKey,
                data: extraData
            });
            onClick(index);
        });
        this.onTabClicked = this.onTabClicked.bind(this);
        this.onKeyDown = generateOnKeyDownHandler(this.tabClickedAction);
    }
}
export { TabComponent as default };
TabComponent.defaultProps = {
    useSmallLabels: false
};
